import { CHANGE_PASSWORD } from "./constant";

export function confrimPasswordRequest(data){
  return {
    type:CHANGE_PASSWORD.PENDING,
    data,
  }
}

export function confrimPasswordSuccess(data){
  return {
    type:CHANGE_PASSWORD.SUCCESS,
    data
  }
}

export function confrimPasswordError(err){
  return {
    type:CHANGE_PASSWORD.ERROR,
    err
  }
}
